import React from "react";

const CopyIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#DCEDFF" />
      <path
        d="M11.3366 10.1697L11.3329 13.0003V27.0059C11.3329 29.3991 13.273 31.3393 15.6662 31.3393L27.1546 31.3397C26.7426 32.5046 25.6316 33.3393 24.3254 33.3393H15.6662C12.1684 33.3393 9.33289 30.5038 9.33289 27.0059V13.0003C9.33289 11.6927 10.1695 10.5805 11.3366 10.1697ZM27.6662 6.66699C29.323 6.66699 30.6662 8.01014 30.6662 9.66699V27.0003C30.6662 28.6571 29.323 30.0003 27.6662 30.0003H15.6662C14.0094 30.0003 12.6662 28.6571 12.6662 27.0003V9.66699C12.6662 8.01014 14.0094 6.66699 15.6662 6.66699H27.6662ZM27.6662 8.66699H15.6662C15.1139 8.66699 14.6662 9.11471 14.6662 9.66699V27.0003C14.6662 27.5526 15.1139 28.0003 15.6662 28.0003H27.6662C28.2185 28.0003 28.6662 27.5526 28.6662 27.0003V9.66699C28.6662 9.11471 28.2185 8.66699 27.6662 8.66699Z"
        fill="#0782C4"
      />
    </svg>
  );
};

export default CopyIcon;
